import { createApi } from '@reduxjs/toolkit/query/react';
import { gql } from 'graphql-request';
import { baseQuery } from '@classity-edtech/ui-base';
import { SUBJECTS } from '../store/actionTypes';

export interface Subject {
  id: string;
  curriculumId: string;
  name: {
    text: string;
  };
  code: string;
  description?: {
    text: string;
  };
}

export const subjects = createApi({
  reducerPath: SUBJECTS,
  baseQuery,
  tagTypes: ['Subject'],
  endpoints: builder => ({
    getSubjects: builder.query<Subject[], { curriculumId?: string; page?: number; limit?: number }>(
      {
        query: variables => ({
          document: gql`
            query GetSubjects($page: Int, $limit: Int, $curriculumId: String) {
              getSubjects(page: $page, limit: $limit, curriculumId: $curriculumId) {
                id
                curriculumId
                name {
                  text
                }
                code
                description {
                  text
                }
              }
            }
          `,
          variables,
        }),
        transformResponse: (response: any) => response?.getSubjects || [],
      },
    ),
  }),
});

export const { useGetSubjectsQuery } = subjects;
